<template>
<div>
<div> <h5 class="alert alert-success center-align ppad">Academic Activities</h5> </div>
  <div class="loadings" id="loading" v-if="LoadingMSG">
    <div class="preloader-wrapper big active">
      <div class="spinner-layer spinner-blue">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div><div class="gap-patch">
          <div class="circle"></div>
        </div><div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>

      <div class="spinner-layer spinner-red">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div><div class="gap-patch">
          <div class="circle"></div>
        </div><div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>

      <div class="spinner-layer spinner-yellow">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div><div class="gap-patch">
          <div class="circle"></div>
        </div><div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>

      <div class="spinner-layer spinner-green">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div><div class="gap-patch">
          <div class="circle"></div>
        </div><div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>
    </div>
  </div>
  <div v-for="( publication, index ) in publications" :key="index">
    <div class="card col s12 m12 l12">
      <!-- <div class="card-image waves-effect waves-block waves-light">
         <img class="activator" src="../assets/AI.png">
      </div> -->
      <div class="card-content">
        <div class="card-title activator grey-text text-darken-4">{{(`${publication.title}`.length >200) ? `${publication.title}`.substring(0,200)+"...":`${publication.title}` |uppercase}}<hr><i class="material-icons right">more_vert</i></div>
        <p>{{ `${publication.abstract}` | truncate(200) }}</p>
      </div>
      
      <div class="card-reveal">
        <span class="card-title grey-text text-darken-4">Abstract<i class="material-icons right">close</i></span>
        <hr>
        <p>{{publication.abstract}}</p>
        <p><a href="https://sehidb8.firebaseapp.com">Download</a></p>
        <!-- <p><a v-bind:href="publication.link">Download</a></p> -->
      </div>
    </div>
  </div>
</div>
</template>
<script>
  
export default {
  name:'myLovelyPublications',
  data(){
    return {
      publications:[],
      LoadingMSG:true
    }
  },
  methods:{
      
  },
  created(){
    this.$http.get('https://sehidb8.firebaseapp.com/apps').then(function(data){
      // this.publications = data;
      this.LoadingMSG=false;
      this.publications=data.data;
    });
  }
}
</script>
<style scoped>
/* .card{
  max-width: 400px;
} */
.card{
  margin: 1em;
  box-shadow: none;
}
.ppad{
  padding: 1.5%;
}
.loadings{
  padding: 1em;
  margin: 1em;
  text-align: center;
}

</style>


